import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Button } from '@mui/material';
import axios from 'axios';

import './../styles/cart-buttons.css'

import { useFloorMatStore } from '../stores/floor-mat-store';
import { FLOOR_MAT_API_URLS } from '../constants/urls';
import { FLOOR_MAT_API_KEY, FLOOR_MAT_BRAND_CODE, FLOOR_MAT_DOMAIN_NAME } from '../constants/api';
import { PRODUCTS_MAP } from '../constants/product';
import { formatMoney, useIsOutOfStock } from '../utils/helpers';

axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

function FloorMatCartButton() {
  const total = useFloorMatStore(state => state.total);
  const minMaxPrices = useFloorMatStore(state => state.minMaxPrices);
  const selectedCar = useFloorMatStore(state => state.selectedCar);
  const selectedMatColor = useFloorMatStore(state => state.selectedMatColor);
  const selectedBorderColor = useFloorMatStore(state => state.selectedBorderColor);
  const selectedPadColor = useFloorMatStore(state => state.selectedPadColor);
  const selectedStitchingColor = useFloorMatStore(state => state.selectedStitchingColor);
  const selectedMatOptions = useFloorMatStore(state => state.selectedMatOptions);

  const productHandle = window?.conspire_product?.handle;
  const isQuiltedFloorMat = productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle;
  const isOutOfStock = useIsOutOfStock(window?.conspire_product?.tags);
  const atcButtonText = isOutOfStock ? 'Out of Stock' : isQuiltedFloorMat ? 'Add to Cart' : 'Pre Order';

  const getDynamicPartNumber = async (option) => {
    const params = {
      brand_code : FLOOR_MAT_BRAND_CODE,
      apikey : FLOOR_MAT_API_KEY,
      domainName : FLOOR_MAT_DOMAIN_NAME,
      product_line_code: option.partNumber.slice(0, 2),
      base_vehicle_id: selectedCar.model.baseVehicleId,
      vehicle_uniques: selectedCar.submodel || 'undefined',
      part_number_list: option.partNumber,
      part_number_list_with_note: option.partNumber + '@' + (option.selectedPartNumberNote ? option.selectedPartNumberNote : ""),
      product_uniques: option.selectedProductUnique ? option.partNumber + '@' + option.selectedProductUnique.product_unique_string : 'undefined',
      product_price_list: option.partNumber + "@0.0",
      color_value: selectedMatColor.name,
      embroidery_type: 'plainmats',
      binding_id: 'STANDARD',
      binding_value: 'Standard',
      shopperId: ''
    }
    let dynamicPartNumber = '';
    const {data: {data}} =
      await axios.post(`${FLOOR_MAT_API_URLS.BASE}${FLOOR_MAT_API_URLS.CART_INFO}`, params);

    dynamicPartNumber = data.dynamic_part_number_string;

    return dynamicPartNumber.replace(/\|/g, '#').split('').reverse().join('');
  }

  const addToCart = async () => {
    if (!selectedMatOptions?.length) {
      return;
    }

    for (const option of selectedMatOptions) {
      let params = {};
      let addHeelPadColor = true;
      const trunkMatPartNumberMinLength =
        productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle ? 5 : 10;
      params.id = option.id;
      params.quantity = 1;

      // if trunkmat don't add heelpad
      if (parseInt(option.partNumber.replace("BB", "")) > trunkMatPartNumberMinLength) {
          addHeelPadColor = false;
      }

      const dynamicPartNumber = await getDynamicPartNumber(option);

      params.properties = {
          'Car': `${selectedCar?.year} ${selectedCar?.make?.makeName} ${selectedCar?.model?.modelName} ${selectedCar?.submodel || ''}`,
          'Make': selectedCar?.make?.makeName,
          'Model': selectedCar?.model?.modelName,
          'Trim': selectedCar?.submodel,
          'Mat Color': productHandle === PRODUCTS_MAP['quilted-leather-floor-mats']?.handle
            ? selectedMatColor.name
            : 'black',
          'Border Color': selectedBorderColor.name,
          'Heel Pad Color': selectedPadColor.name,
          'Stitching Color': selectedStitchingColor.name,
          'Product Unique': option.selectedProductUnique.product_unique_string,
          'Part Number String': dynamicPartNumber
      };

      if (!addHeelPadColor) {
        delete params.properties['Heel Pad Color'];
      }

      // console.log('addToCart params', params);

      const { data } = await axios.post('/cart/add.js', params);

      // console.log('addToCart data', data);
    }

    window.location.href = encodeURI('/cart');
  }

  return (
    <section className='cart-buttons-wrapper floor-mat-cart-buttons-wrapper'>
      <Grid container className="cart-buttons-container">
        <Grid item xs={6}>
          <div className="cart-total-container">
            {total === 0 ? (
              <p className="cart-total-text">From {minMaxPrices}</p>
            ) : (
              <p className="cart-total-text">Total: {formatMoney(total / 100)}</p>
            )}
          </div>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={addToCart}
            className={`add-to-cart-button ${isOutOfStock ? 'disabled' : ''}`}
            disabled={isOutOfStock}
          >
            {atcButtonText}
          </Button>
        </Grid>
      </Grid>
    </section>
  )
}

export default FloorMatCartButton
